import { CMButton, CMButtonProps } from "@pscsrvlab/psc-react-components";
import React from "react";

export type CommonNextButtonProps = CMButtonProps;
export const CommonNextButton = (props: CommonNextButtonProps) => {
  return <CMButton minW={"160px"} minH={"40px"} {...props} />;
};
